import { PayrollDetails } from "../model";
import { Configs } from "./Configs";

/**
 * Logic related to Payroll.
 */
export class PayrollLogic {

  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public static getBlank(): PayrollDetails {
    return {
      input: {
        period: {},
        calculations: [],
      },
      info: {
        applicationId: Configs.current?.applicationId,
      },
      calcs: [],
      validations: [],
      workflowData: {},
    };
  }
}